import { mixins, styled } from '@bob/library'
import { Asset } from '@websrc/App/Components/Asset/Asset'

export const Wrapper = styled.div<{ hidden?: boolean }>`
  display: ${({ hidden }: { hidden?: boolean }) => (hidden ? 'none' : 'flex')};
  align-items: center;
  padding: 8px 0;

  &:first-of-type {
    padding-top: 16px;
  }
  &:not(:first-of-type) {
    padding-top: 8px;
  }
`

export const ProductImage = styled(Asset)`
  flex-shrink: 0;
`

export const ContentWrapper = styled.div`
  ${mixins.padding.left(10)}
  width: 180px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`

export const ProductName = styled.div``

export const ProductNumber = styled.div`
  ${mixins.typography.subtitleSmall}
  margin-top: 10px;
  color: ${({ theme }: { theme: any }) => theme.color.grayDark};
`

export const QuanPriceWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 15px;
`
export const PriceLabel = styled.div``

export const QuantityWrapper = styled.div``

export const QuantityLabel = styled.div`
  ${mixins.typography.subtitleSmall}
  padding-bottom: 10px;
  display: inline-block;
`
export const ButtonTertiary = styled.button`
  ${mixins.cta.tertiary('black')}
`
